export default {"src":"/_next/static/media/Step3.9e5cef75.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};